module.exports = __webpack_public_path__ + "img/6.5e46dc49.png";